<template>
  <div class="content">
  	<div class="container home padding-top">
    	<menu-home>
        <div slot="title">Seleccione</div>
        <div slot="buttons" aria-label="Justified button group" role="group" class="btn-group btn-group-justified">
          <menu-button menu-url="home/championships" glyph-icon="glyphicon-list-alt">Lista de Campeonatos</menu-button>
          <menu-button menu-url="configuration" glyph-icon="glyphicon-cog">Preferencias</menu-button>
        </div>
      </menu-home>
    </div>
    <router-view></router-view>
  </div>
</template>
<script>
import MenuHome from '../components/MenuHome'
import MenuButton from '../components/MenuButton'

export default {
  components: { MenuHome, MenuButton }
}

</script>



/** WEBPACK FOOTER **
 ** Home.vue?f4e4b918
 **/